/**
 * Currency formatting for unified reports (client + server safe — no DB imports).
 * Used by FinanceReportViewer and adapter fmtCurrency.
 */

const DEFAULT_CURRENCY = 'ZAR';

export function intlLocaleForCurrency(iso4217: string): string {
  const c = iso4217.toUpperCase();
  if (c === 'ZAR') return 'en-ZA';
  if (c === 'USD') return 'en-US';
  if (c === 'GBP') return 'en-GB';
  if (c === 'EUR') return 'de-DE';
  if (c === 'BWP') return 'en-BW';
  if (c === 'NAD') return 'en-NA';
  if (c === 'AUD') return 'en-AU';
  if (c === 'CAD') return 'en-CA';
  if (c === 'MZN') return 'pt-MZ';
  if (c === 'NGN') return 'en-NG';
  if (c === 'KES') return 'sw-KE';
  if (c === 'ZMW') return 'en-ZM';
  return 'en-US';
}

/**
 * Format a monetary amount using Intl (currency code must be ISO 4217 where possible).
 */
export function formatUnifiedCurrency(
  amount: number | string | null | undefined,
  currency: string = DEFAULT_CURRENCY,
): string {
  const raw = typeof amount === 'string' ? parseFloat(amount) : amount ?? 0;
  const num = Number.isFinite(raw) ? Number(raw) : 0;
  const code =
    String(currency || DEFAULT_CURRENCY)
      .trim()
      .toUpperCase() || DEFAULT_CURRENCY;

  try {
    return new Intl.NumberFormat(intlLocaleForCurrency(code), {
      style: 'currency',
      currency: code,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return `${code} ${num.toFixed(2)}`;
  }
}
